import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ImageUploader from "vue-image-upload-resize";
import "./assets/style.css";

import { BootstrapVue } from "bootstrap-vue";
import Loading from "./utils/pluiigns/Loading/loading"

Vue.use(Loading)

// Install BootstrapVue
Vue.use(ImageUploader);

Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;

//VeeValidate validation for vue
import VeeValidate, { Validator } from "vee-validate";

//sweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);


import es from "vee-validate/dist/locale/es";


Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields'
});
Validator.localize("es", es);



new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
